/**
 * Black-Swan Global Filters
 *
 * @since: 2018-07-24
 * @author: kdydesign.kim
 */

import Vue from 'vue'

// global Multi Select Component ToolTip Filters
import MultiSelectFilter from './multiSelectFilter'

// global filters
Vue.filter('multiSelectFilter', MultiSelectFilter)
